import API from './api';

// Podium (wishlist #17): earnings-call transcripts the Mac mini pushes through the Courier connector; superuser reads +
// the review decision. The platform never runs a model here.
const podiumService = {
  getCalls: () => API.get('/api/podium/calls/'),
  getCall: (slug) => API.get(`/api/podium/calls/${slug}/`),
  getReview: (status = 'open') => API.get('/api/podium/review/', { params: { status } }),
  resolveReview: (id, action, data) => API.post(`/api/podium/review/${id}/resolve/`, { action, data }),
  getPeople: () => API.get('/api/podium/people/'),
  getPerson: (key) => API.get(`/api/podium/people/${key}/`),
};

export default podiumService;
